import { request } from '@/shared/api/request'

export const getWorkLog = () => {
	return request({ url: '/contract/getEmployeeData', method: 'GET' })
}

export const createWorkLog = (data) => {
	return request({ url: '/contract/createWorklog', method: 'POST', data: data })
}

export const updateWorkLog = (data) => {
	return request({ url: '/contract/updateWorklog', method: 'POST', data: data })
}

export const deleteWorklog = ({ params }) => {
	return request({ url: '/contract/deleteWorklog', method: 'DELETE', params })
}

export const deleteDay = ({ params }) => {
	return request({ url: '/contract/deleteDay', method: 'DELETE', params })
}
